(function() {

  function getPrenom() {
    var input = document.getElementById('patch-input');
    return input ? input.value.trim() : '';
  }

  function isPatchSelected() {
    var cb = document.querySelector('input[class*="add_upsell_0"]');
    return cb ? cb.checked : false;
  }

  function showPrenomField(show) {
    var wrapper = document.getElementById('patch-wrapper');
    var input = document.getElementById('patch-input');
    if (!wrapper) return;
    wrapper.style.display = show ? 'block' : 'none';
    if (!show && input) input.value = '';
  }

  // Bloquer le bouton si prénom manquant
  function validateAndBlock() {
    if (!isPatchSelected()) return true;
    var prenom = getPrenom();
    if (!prenom) {
      var input = document.getElementById('patch-input');
      if (input) {
        input.style.borderColor = 'red';
        input.focus();
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }
    return true;
  }

  // Après que Rapi ajoute au panier, on met à jour les properties
  function updateCartWithPrenom(prenom) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var updates = {};
        var changes = [];

        cart.items.forEach(function(item, index) {
          var props = Object.assign({}, item.properties || {});
          props['Prenom brode'] = prenom;
          changes.push({
            id: item.key,
            properties: props
          });
        });

        // Utiliser cart/change pour chaque item
        var chain = Promise.resolve();
        changes.forEach(function(change) {
          chain = chain.then(function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: change.id, properties: change.properties })
            });
          });
        });

        return chain;
      })
      .then(function() {
        console.log('[Naseyla] Prénom ajouté au panier ✅');
      })
      .catch(function(e) {
        console.warn('[Naseyla] Erreur update panier:', e);
      });
  }

  // Intercepter le clic sur le bouton "Ajouter au panier"
  function setupCartButton() {
    var btn = document.querySelector('[data-rapi-button], .rapi-add-to-cart, form[action="/cart/add"] button[type="submit"], button.btn-addtocart');
    if (!btn) {
      // Cherche plus large
      btn = document.querySelector('button[name="add"], .product-form__submit');
    }
    if (btn) {
      btn.addEventListener('click', function(e) {
        if (!validateAndBlock()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
        var prenom = getPrenom();
        if (prenom && isPatchSelected()) {
          // Attendre que Rapi finisse d'ajouter (500ms) puis update
          setTimeout(function() {
            updateCartWithPrenom(prenom);
          }, 1500);
        }
      }, true); // capture phase = avant Rapi
    }
  }

  function setupVisibility() {
    var cb = document.querySelector('input[class*="add_upsell_0"]');
    if (cb) {
      cb.addEventListener('change', function() {
        showPrenomField(cb.checked);
      });
      showPrenomField(cb.checked);
    }
  }

  function trySetup(attempts) {
    var cb = document.querySelector('input[class*="add_upsell_0"]');
    if (cb) {
      setupVisibility();
      setupCartButton();
    } else if (attempts > 0) {
      setTimeout(function() { trySetup(attempts - 1); }, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { trySetup(20); });
  } else {
    trySetup(20);
  }

})();
